export interface Section {
  name: string;
  steps: number;
  order: number;
}

export interface Sections {
  residence: Section;
  transport: Section;
  energy: Section;
  nutrition: Section;
  householdHabits: Section;
}

export type SectionName = keyof Sections;

export const SECTIONS: Sections = {
  residence: {
    name: "Vivienda",
    steps: 2,
    order: 0,
  },
  transport: {
    name: "Movilidad",
    steps: 3,
    order: 1,
  },
  energy: {
    name: "Energía",
    steps: 3,
    order: 2,
  },
  nutrition: {
    name: "Alimentación",
    steps: 3,
    order: 3,
  },
  householdHabits: {
    name: "Además...",
    steps: 3,
    order: 4,
  },
};
